export enum enmStopFreeSaleAppType {
    AccommodationBased = 0,
    EntryBased = 1
}
